/** 服务端图片等资源按 API 来源解析，不能在桌面端落到 file://。 */
export function apiResourceUrl(value: string | null | undefined, origin: string): string | undefined {
  if (!value) return undefined;
  return value.startsWith('/api/') ? new URL(value, `${origin}/`).href : value;
}
